import { createSelector } from 'reselect'
import createSortedLabelsSelector from 'routes/Board/selectors/createSortedLabelsSelector'

export const getIsArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getLabels = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].labels
}

export const getLabelsById = (state, props) => {
  return state['view-board'].labels.labelsById
}

export const sortedLabelsSelector = createSelector(
  [
    getLabels,
    getLabelsById
  ],
  (
    labels,
    labelsById
  ) =>
    labels
      .slice()
      .sort((a, b) => labelsById[a].position - labelsById[b].position)
)

const getBoardLabels = (state, props) => {
  return state['view-board'].labels[state['view-board'].cards[props.cardContext.id].boardId].labels
}

export default () => {
  const sortedBoardLabelsSelector = createSortedLabelsSelector(getBoardLabels)

  return createSelector(
    [
      getIsArchived,
      sortedLabelsSelector,
      getLabelsById,
      sortedBoardLabelsSelector
    ],
    (
      isArchived,
      labels,
      labelsById,
      boardLabels
    ) => ({
      isArchived,
      labels,
      labelsById,
      boardLabels
    })
  )
}
